import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const server = [
    {
        path: '/choiceFiveOpenDevice',
        name: 'ChoiceFiveOpenDevice',
        component: () => import('../../views/Home/fiveOpenModel/choiceFiveOpenDevice.vue')
    },
    {
        path: '/fiveOpenModel',
        name: 'FiveOpenModel',
        component: () => import('../../views/Home/fiveOpenModel')
    },
]

export default server